/* ================================================================
   3E by Charris Store — Theme JS
   Mobile drawer · Cart drawer (AJAX) · Variant picker · Toasts
   Uses the Shopify Cart AJAX API + Section Rendering API.
   ================================================================ */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  var routes = window.routes || {};
  var strings = window.themeStrings || {};

  // ------------------------------------------------------------
  // Toast
  // ------------------------------------------------------------
  function toast(msg) {
    if (!msg) return;
    var host = $('.toast-container');
    if (!host) {
      host = document.createElement('div');
      host.className = 'toast-container';
      host.setAttribute('role', 'status');
      host.setAttribute('aria-live', 'polite');
      document.body.appendChild(host);
    }
    var t = document.createElement('div');
    t.className = 'toast';
    t.textContent = msg;
    host.appendChild(t);
    setTimeout(function () {
      t.style.transition = 'opacity .3s';
      t.style.opacity = 0;
      setTimeout(function () { t.remove(); }, 300);
    }, 2400);
  }

  // ------------------------------------------------------------
  // Drawers (mobile menu + cart)
  // ------------------------------------------------------------
  var lastFocused = null;

  function openDrawer(el) {
    if (!el) return;
    lastFocused = document.activeElement;
    el.classList.add('open');
    document.body.style.overflow = 'hidden';
    var focusable = el.querySelector('button, a[href], input, select, textarea');
    if (focusable) focusable.focus();
  }

  function closeDrawer(el) {
    if (!el) return;
    el.classList.remove('open');
    document.body.style.overflow = '';
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  function openCartDrawer() { openDrawer($('[data-cart-drawer]')); }
  function closeCartDrawer() { closeDrawer($('[data-cart-drawer]')); }

  document.addEventListener('click', function (e) {
    var openMenu = e.target.closest('[data-open-menu]');
    if (openMenu) { e.preventDefault(); openDrawer($('[data-mobile-drawer]')); return; }

    var closeMenu = e.target.closest('[data-close-menu]');
    if (closeMenu) { e.preventDefault(); closeDrawer($('[data-mobile-drawer]')); return; }

    var openCart = e.target.closest('[data-open-cart]');
    if (openCart && $('[data-cart-drawer]')) { e.preventDefault(); openCartDrawer(); return; }

    var closeCart = e.target.closest('[data-close-cart]');
    if (closeCart) { e.preventDefault(); closeCartDrawer(); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = $('.cart-drawer.open') || $('.mobile-drawer.open');
    if (open) closeDrawer(open);
  });

  // ------------------------------------------------------------
  // Cart — section rendering
  // ------------------------------------------------------------
  // Every element that should be refreshed after a cart mutation carries
  // data-cart-section="<section id>". Its innerHTML is replaced with the
  // freshly rendered section markup.
  function cartSectionIds() {
    return $$('[data-cart-section]')
      .map(function (el) { return el.dataset.cartSection; })
      .filter(function (id, i, arr) { return id && arr.indexOf(id) === i; });
  }

  function applySections(sections) {
    if (!sections) return;
    $$('[data-cart-section]').forEach(function (el) {
      var html = sections[el.dataset.cartSection];
      if (typeof html !== 'string') return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var source = doc.querySelector('[data-cart-section="' + el.dataset.cartSection + '"]');
      el.innerHTML = source ? source.innerHTML : (doc.querySelector('.shopify-section') || doc.body).innerHTML;
    });
  }

  function cartRequest(url, body) {
    body.sections = cartSectionIds().join(',');
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw data;
        return data;
      });
    });
  }

  function changeLine(line, quantity, scope) {
    if (scope) scope.classList.add('is-loading');
    return cartRequest(routes.cart_change_url + '.js', { line: line, quantity: quantity })
      .then(function (data) {
        applySections(data.sections);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: data } }));
      })
      .catch(function (err) {
        toast((err && err.description) || strings.cartError || 'Something went wrong');
      })
      .finally(function () {
        if (scope) scope.classList.remove('is-loading');
      });
  }

  // Quantity +/- and remove, delegated so it survives section re-renders
  document.addEventListener('click', function (e) {
    var change = e.target.closest('[data-cart-change]');
    if (change) {
      e.preventDefault();
      var line = change.dataset.line;
      var qty = parseInt(change.dataset.cartChange, 10);
      changeLine(line, qty, change.closest('.cart-line, .cart-list-item'));
      return;
    }
    var remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      e.preventDefault();
      changeLine(remove.dataset.line, 0, remove.closest('.cart-line, .cart-list-item'));
    }
  });

  // Typed quantity inputs
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty-input]');
    if (!input) return;
    var qty = Math.max(0, parseInt(input.value, 10) || 0);
    changeLine(input.dataset.line, qty, input.closest('.cart-line, .cart-list-item'));
  });

  // Cart note
  document.addEventListener('change', function (e) {
    var note = e.target.closest('[data-cart-note]');
    if (!note) return;
    fetch(routes.cart_update_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: note.value })
    });
  });

  // ------------------------------------------------------------
  // Add to cart (product forms + quick add)
  // ------------------------------------------------------------
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();

    var button = form.querySelector('[type="submit"]');
    var errorEl = form.querySelector('[data-form-error]');
    if (errorEl) { errorEl.textContent = ''; errorEl.hidden = true; }
    if (button) { button.classList.add('is-loading'); button.disabled = true; }

    var formData = new FormData(form);
    formData.append('sections', cartSectionIds().join(','));
    formData.append('sections_url', window.location.pathname);

    fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
      body: formData
    })
      .then(function (res) { return res.json().then(function (d) { if (!res.ok) throw d; return d; }); })
      .then(function (data) {
        applySections(data.sections);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: data } }));
        toast(strings.addedToBag || 'Added to bag');
        if ($('[data-cart-drawer]')) openCartDrawer();
      })
      .catch(function (err) {
        var msg = (err && (err.description || err.message)) || strings.cartError || 'Something went wrong';
        if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; } else { toast(msg); }
      })
      .finally(function () {
        if (button) { button.classList.remove('is-loading'); button.disabled = false; }
      });
  });

  // ------------------------------------------------------------
  // Quantity picker (product page)
  // ------------------------------------------------------------
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    e.preventDefault();
    var wrap = btn.closest('.qty-picker');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var min = parseInt(input.min, 10) || 1;
    var next = (parseInt(input.value, 10) || min) + parseInt(btn.dataset.qtyStep, 10);
    input.value = Math.max(min, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // ------------------------------------------------------------
  // Variant picker
  // ------------------------------------------------------------
  // The picker re-renders the product section server-side so price,
  // availability, badges and SKU always match the Liquid source of truth.
  function initVariantPicker(root) {
    var picker = root.querySelector('[data-variant-picker]');
    if (!picker) return;

    var sectionId = picker.dataset.sectionId;
    var productUrl = picker.dataset.productUrl;
    var dataEl = root.querySelector('[data-variant-data]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    picker.addEventListener('change', function () {
      var selected = $$('input[type="radio"]:checked, select', picker).map(function (el) { return el.value; });

      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });

      // Reflect the chosen option label immediately, before the fetch lands
      $$('[data-option-selected]', picker).forEach(function (el) {
        var pos = parseInt(el.dataset.optionSelected, 10);
        if (selected[pos - 1]) el.textContent = selected[pos - 1];
      });

      if (!match) {
        var addBtn = root.querySelector('[data-add-cart]');
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = strings.unavailable || 'Unavailable'; }
        return;
      }

      var url = productUrl + '?variant=' + match.id;
      window.history.replaceState({}, '', url);

      fetch(url + '&section_id=' + sectionId)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          ['[data-price-line]', '[data-buy-buttons]', '[data-sku]', '[data-pdp-media]', '[data-variant-badge]'].forEach(function (sel) {
            var fresh = doc.querySelector(sel);
            var current = root.querySelector(sel);
            if (fresh && current) current.innerHTML = fresh.innerHTML;
          });
          var freshId = doc.querySelector('[data-variant-id]');
          var currentId = root.querySelector('[data-variant-id]');
          if (freshId && currentId) currentId.value = freshId.value;
        });
    });
  }

  // ------------------------------------------------------------
  // Product media thumbnails
  // ------------------------------------------------------------
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-media-thumb]');
    if (!thumb) return;
    e.preventDefault();
    var gallery = thumb.closest('[data-media-gallery]');
    var main = gallery && gallery.querySelector('[data-media-main] img');
    var img = thumb.querySelector('img');
    if (!main || !img) return;
    main.src = img.dataset.full || img.src;
    main.srcset = img.dataset.fullSrcset || '';
    main.alt = img.alt;
    $$('[data-media-thumb]', gallery).forEach(function (t) { t.setAttribute('aria-current', 'false'); });
    thumb.setAttribute('aria-current', 'true');
  });

  // ------------------------------------------------------------
  // Search page: clear button
  // ------------------------------------------------------------
  function initSearch(root) {
    var input = root.querySelector('[data-search-input]');
    var clear = root.querySelector('[data-search-clear]');
    if (!input || !clear) return;
    var sync = function () { clear.hidden = !input.value; };
    sync();
    input.addEventListener('input', sync);
    clear.addEventListener('click', function () { input.value = ''; sync(); input.focus(); });
  }

  // ------------------------------------------------------------
  // Init (re-runs when the theme editor re-renders a section)
  // ------------------------------------------------------------
  function init(root) {
    initVariantPicker(root);
    initSearch(root);
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('[data-cart-drawer]')) openCartDrawer();
  });

  window.Theme = {
    toast: toast,
    openCartDrawer: openCartDrawer,
    closeCartDrawer: closeCartDrawer,
    changeLine: changeLine
  };
})();
